'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  search: {
    placeholder: 'Suche'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'PREMIUM INFO',
    link: '/news-service'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'KUNDEN LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUKTE'
    },
    list: [{
      text: 'Travel',
      src: '/travel-and-expense/reisemanagement'
    }, {
      text: 'TripLink',
      src: '/triplink'
    }, {
      text: 'Expense',
      src: '/reisekostenabrechnung'
    }, {
      text: 'Travel & Expense',
      src: '/travel-and-expense'
    }, {
      text: 'Intelligence',
      src: '/business-intelligence'
    }, {
      text: 'Consultative Intelligence',
      src: '/consultative-intelligence'
    }, {
      text: 'Concur Locate',
      src: '/fuersorgepflicht'
    }, {
      text: 'Budget',
      src: '/budget-management'
    }, {
      text: 'User Support Desk',
      src: '/user-support-desk'
    }, {
      text: 'Service Administration',
      src: '/service-administration'
    }, {
      text: 'Concur Drive',
      src: '/fahrtstreckenabrechnung '
    }, {
      text: 'Interaktive Concur Expense Demo',
      src: '/self-guided-demo-expense-de-de',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESSOURCEN'
    },
    list: [{
      text: 'Downloads',
      src: '/resource-center'
    }, {
      text: 'Kundenbeispiele',
      src: '/casestudy'
    }, {
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'News-Service',
      src: '/news-service'
    }]
  }, {
    title: {
      text: 'ÜBER SAP CONCUR'
    },
    list: [{
      text: 'Concur im Überblick',
      src: '/ueber-concur'
    }, {
      text: 'Partner',
      src: '/partner'
    }, {
      text: 'Plattform',
      src: '/verbundene-plattform'
    }, {
      text: 'App-Center',
      src: '/app-center'
    }, {
      text: 'Karriere',
      src: '/karriere'
    }, {
      text: 'Standorte',
      src: '/contact/offices'
    }, {
      text: 'Ansprechpartner',
      src: '/kontakt/ansprechpartner'
    }, {
      text: 'Für Kunden',
      src: '/kunden'
    }, {
      text: 'Support',
      src: '/support'
    }, {
      text: 'Datenschutz',
      src: '/datenschutz'
    }, {
      text: 'Impressum',
      src: '/impressum'
    }, {
      text: 'Veranstaltungen',
      src: '/veranstaltungen'
    }, {
      text: 'Kontakt',
      src: '/kontakt',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR NEWSROOM',
    href: '/newsroom'
  }, {
    text: 'KONTAKT',
    href: '/kontakt'
  }, {
    text: 'SUPPORT',
    href: '/support'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};